import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UsersService } from 'src/app/services/users.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  userName: string = ''
  userId: number
  url: string
  date: Date
  heDate: string
  constructor(private userService: UsersService, private router: Router, private utils: UtilsService) { }

  ngOnInit(): void {
    this.date = new Date()
    let hdate1 = new Intl.DateTimeFormat('he-IL-u-ca-hebrew', { weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric' }).format(new Date())
    this.utils.convertToHebrewDate(this.date).subscribe(hd => {
      this.heDate = `${hdate1.split(',')[0]} ${hd['heDateParts']['d']} ${hd['heDateParts']['m'].replace('\"', '')} ה${hd['heDateParts']['y']} `

      console.log(hd)
      console.log(this.heDate)
      console.log(hdate1)
    }, e => console.error(e))
    this.userService.currentUser.subscribe(u => {
      if (u) {
        this.userId = u.userId
        this.userService.getUserName(this.userId).subscribe(d =>//some of the data is not updated from the redis. so you cant trust the db
          this.userName = d['UserData']['firstname'] + ' ' + d['UserData']['lastname']
        )
      }
    })
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.url = window.location.pathname
      }
    });
  }

  logout() {
    this.userService.logout()
  }

  closeMenu() {
    if (document.getElementById("menuToggle").getAttribute("aria-expanded") === "true") {
      document.getElementById("menuToggle").click();
    }
  }

  moveUserArea() {
    if (document.getElementById("menuToggle").getAttribute("aria-expanded") === "true")
      setTimeout(() => document.getElementById('user-area').classList.remove('moved'), 350)
    else
      document.getElementById('user-area').classList.add('moved')
  }

}
